module.exports = "<!-- begin::Scroll Top -->\n<div id=\"m_scroll_top\" class=\"m-scroll-top\" appunwraptag=\"\">\n\t<i class=\"la la-arrow-up\"></i>\n</div>\n<!-- end::Scroll Top -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/scroll-top/scroll-top.component.html
// module id = ./src/app/theme/layouts/scroll-top/scroll-top.component.html
// module chunks = main